export {
	slideAndFade,
	fade,
	scaleAndFade,
	dialogSlideUpAndFade,
	dialogFade,
} from '../animations/presets';
export type {
	TAnimationPreset,
	TPopoverAnimationPreset,
	TDialogAnimationPreset,
} from '../animations/types';
